import { Box, Typography } from "@mui/material"

import { PaymentBlockProps } from "./props"
import {
  CardLabel,
  CardTopContainer,
  Container,
  DescriptionContainer,
  ChangeButton,
  ToolsContainer,
  Card,
  IconsContainer,
} from "./styled"
import IconBox from "../IconBox"

export const PaymentInfoBlock = ({
  icons,
  description,
  title,
  footer,
  margin,
  onClick,
}: PaymentBlockProps) => {
  const isArray = Array.isArray(icons)

  return (
    <Card sx={{ margin: `${margin}` }}>
      <Container>
        <CardTopContainer>
          <CardLabel>{title}</CardLabel>
          {onClick && (
            <ChangeButton
              variant="text"
              onClick={() => {
                onClick()
              }}
            >
              Изменить
            </ChangeButton>
          )}
        </CardTopContainer>
        {!isArray ? (
          <ToolsContainer>
            <Box>{icons}</Box>
            <DescriptionContainer>
              <Typography variant="h4"> {description.main}</Typography>
              <Typography variant="h5"> {description.secondary}</Typography>
            </DescriptionContainer>
          </ToolsContainer>
        ) : (
          <>
            <Typography sx={{ mt: "-10px" }} variant="h7Pale">
              {" "}
              {description.secondary}
            </Typography>
            <IconsContainer>
              {icons?.map((bankIcon) => (
                <IconBox key={String(bankIcon.key)}>{bankIcon}</IconBox>
              ))}
            </IconsContainer>
          </>
        )}
        {footer && <Typography variant="h5">{footer}</Typography>}
      </Container>
    </Card>
  )
}
